(function () {

    'use strict';

    angular
        .module('app')
        .factory('ELCService', ELCService)

    function ELCService($http, $q, $rootScope, WebAPIUrl) {

        var service = {

            getBrandDefaultsByBrandId: getBrandDefaultsByBrandId
        };

        return service;

        function getBrandDefaultsByBrandId(brandId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/ELC/GetBrandDefaults?BrandId=' + brandId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }
    }
})();